import { render, staticRenderFns } from "./characterStoryInfo.vue?vue&type=template&id=e15c96ee&scoped=true"
import script from "./characterStoryInfo.vue?vue&type=script&lang=js"
export * from "./characterStoryInfo.vue?vue&type=script&lang=js"
import style0 from "./characterStoryInfo.vue?vue&type=style&index=0&id=e15c96ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e15c96ee",
  null
  
)

export default component.exports